export default __webpack_public_path__ + "img/team.90e9d79a.png";